import { Button } from "@mui/material";
import { rgba, shade } from "polished";
import React from "react";
import { ClipLoader } from "react-spinners";

import type { CustomButtonPrimaryProps } from "./interfaces";

const CustomButton: React.FC<CustomButtonPrimaryProps> = ({
  id,
  onClick,
  text,
  background,
  loading,
  disabled,
  type,
  size = "medium",
  icon,
}) => {
  return (
    <Button
      sx={{
        width: "100%",
        background: "#76A6C2",
        border: "1px solid",
        textTransform: "capitalize",
        borderColor: "#76A6C2",
        "&:hover": {
          background: shade(0.5, "#76A6C2"),
        },
        "&:disabled": {
          background: "#d5d5d5",
          color: rgba("#000", 0.5),
        },
        color: background === "#fff" ? "#76A6C2" : "white",
      }}
      size={size}
      variant="contained"
      id={id}
      onClick={onClick}
      type={type}
      disabled={disabled || loading}
      startIcon={!loading && icon}
    >
      {loading ? <ClipLoader color="white" size={20} /> : text}
    </Button>
  );
};

export default CustomButton;
